function toPrecise(num) {
  return Number.parseFloat(num.toFixed(1))
}

function measureElementHeight(element) {
  if (!(element instanceof HTMLElement)) {
    return 0
  }
  const { height } = element.getBoundingClientRect()
  return Number.isFinite(height) ? toPrecise(height) : 0
}

function updateHeaderHeights() {
  const headerHeight = measureElementHeight(
    document.querySelector('sticky-header')
  )
  const topbarHeight = measureElementHeight(
    document.querySelector('sticky-header [ref="topbar"]')
  )
  const rootStyle = document.documentElement.style
  rootStyle.setProperty('--header-height', `${headerHeight}px`)
  rootStyle.setProperty('--topbar-height', `${topbarHeight}px`)
}

let pendingHeaderUpdate = null
let headerResizeObserver = null
let headerTrackingInitialized = false

function scheduleHeaderMeasurement() {
  if (pendingHeaderUpdate !== null) {
    return
  }

  pendingHeaderUpdate = requestAnimationFrame(() => {
    pendingHeaderUpdate = null
    updateHeaderHeights()
  })
}

function observeHeaderElements() {
  if (typeof ResizeObserver === 'undefined') {
    return
  }

  const elements = Array.from(
    document.querySelectorAll('sticky-header')
  ).filter(
    (el, index, array) =>
      el instanceof HTMLElement && array.indexOf(el) === index
  )

  if (!elements.length) {
    if (headerResizeObserver) {
      headerResizeObserver.disconnect()
    }
    return
  }

  if (headerResizeObserver) {
    headerResizeObserver.disconnect()
  } else {
    headerResizeObserver = new ResizeObserver(() => scheduleHeaderMeasurement())
  }

  for (const element of elements) {
    headerResizeObserver.observe(element)
  }
}

function ensureHeaderTracking() {
  if (headerTrackingInitialized) {
    return
  }
  headerTrackingInitialized = true

  const recalc = () => {
    observeHeaderElements()
    scheduleHeaderMeasurement()
  }

  recalc()

  window.addEventListener('resize', scheduleHeaderMeasurement, {
    passive: true
  })
  window.addEventListener('orientationchange', scheduleHeaderMeasurement, {
    passive: true
  })
  window.addEventListener('load', recalc, { once: true })
  window.addEventListener('pageshow', recalc)

  document.addEventListener('shopify:section:load', recalc)
  document.addEventListener('shopify:section:unload', recalc)
  document.addEventListener('shopify:section:select', recalc)
  document.addEventListener('shopify:section:deselect', recalc)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ensureHeaderTracking, {
    once: true
  })
} else {
  ensureHeaderTracking()
}
